import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { AppDispatch, RootState } from "../store/store";

import "../assets/styles/index.css";
import useCustomStyles from "../hooks/useCustomStyles";
import useMediaQuery from "../hooks/useMediaQuery";
import { sideNavigationStyles } from "../assets/styles/sideNavigation";
import { selectTranslationState } from "../store/slices/languageSlice";
import { Business } from "../store/slices/businessSlice";
import { setIsSideNavOpen } from "../store/slices/authSlice";
import { MOBILE_MEDIA_QUERY } from "../utils/breakpoints";

function SideNavigation() {
  const { theme, activeTheme , textTheme} = useSelector(
    (state: RootState) => state.theme_slice
  );
  const { businesses } = useSelector((state: RootState) => state.business_slice);
  const [userBusiness, setUserBusiness] = useState<Business | null>(null);
  useEffect(() => {
    console.log("businesses in side navigation", businesses);
    const userBusiness = businesses.find((business) => business.id === user?.business?.id);
    setUserBusiness(userBusiness || null);
    setEnableAdvisors(userBusiness?.enable_advisors || false);
  }, [businesses]);
  const classes = useCustomStyles(sideNavigationStyles, theme);
  const { t } = useSelector(selectTranslationState);
  // Get the user object from the state
  const { user, isSideNavOpen } = useSelector((state: RootState) => state.auth_slice); // Adjust this according to your state structure
  const dispatch = useDispatch<AppDispatch>();
  const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    // console.log("toggleMenus", isMenuOpen);
    setIsMenuOpen(!isMenuOpen);
    // On mobile the sidebar overlays content - close it after a nav pick so
    // it doesn't stay covering the page the user just navigated to.
    if (isMobile && isSideNavOpen) {
      dispatch(setIsSideNavOpen());
    }
  };
  const [enable_advisors, setEnableAdvisors] = useState(userBusiness?.enable_advisors);
  const [isElisMasterAdmin, setIsElisMasterAdmin] = useState(false);
  useEffect(() => {
    if(userBusiness){
    const isMasterAdmin = ((userBusiness?.name?.toLocaleLowerCase() === "elisyan" || ( userBusiness?.name?.toLocaleLowerCase() === "elisyan-test")) && (user?.roles.includes("master")));
    setIsElisMasterAdmin(isMasterAdmin? true : false);
    }
  },[userBusiness]);
  // Check if the user is an admin of the 'elisyan' business
  const isElisyanMasterAdmin = ((user?.business?.name === "elisyan" || ( user?.business?.name === "elisyan-test")) && (user?.roles.includes("master")));
  const isElisyanAdmin = (user?.business?.name === "elisyan" || user?.business?.name === "elisyan-test");
  const isSopherAdmin =
    user?.business?.name === "sopher" || user?.business?.name === "sopher-test";
  const isOlympeAdmin =
    user?.business?.name == "OLYMPE" || user?.business?.name == "OLYMPE_TEST";

  console.log("user *****>", user);
  return (
    <div>
      <ul
        onClick={() => toggleMenu()}
        className={`${classes?.navigationList} ${
          isMenuOpen ? classes?.navigationListOpen : ""
        }`}
      >
        {/* <li className={classes.listItem}>
          <ProfileSection />
        </li> */}

        <li className={classes.listItem}>
          <NavLink
            to="/"
            className={({ isActive }) =>
              `${classes?.link} ${isActive ? classes?.activeLink : ""}`
            }
          >
            {t[textTheme].header.navigationList.link5}
          </NavLink>
        </li>
        <li className={classes.listItem}>
          <NavLink
            to="/clients"
            className={({ isActive }) =>
              `${classes?.link} ${isActive ? classes?.activeLink : ""}`
            }
          >
            {t[textTheme].header.navigationList.link_clients}
          </NavLink>
        </li>
        {enable_advisors || isElisMasterAdmin ? (
          <li className={classes.listItem}>
            <NavLink
              to="/advisors"
              className={({ isActive }) =>
                `${classes?.link} ${isActive ? classes?.activeLink : ""}`
              }
            >
              {t[textTheme].header.navigationList.link_advisors}
            </NavLink>
          </li>
        ) : null}
        <li className={classes.listItem}>
          <NavLink
            to="/accessCodes"
            className={({ isActive }) =>
              `${classes?.link} ${isActive ? classes?.activeLink : ""}`
            }
          >
            {t[textTheme].header.navigationList.link_access_codes}
          </NavLink>
        </li>
        {isElisyanAdmin && (
          <>
            <li className={classes.listItem}>
              <NavLink
                to="/contracts"
                className={({ isActive }) =>
                  `${classes?.link} ${isActive ? classes?.activeLink : ""}`
                }
              >
                {t[textTheme].header.navigationList.link6}
              </NavLink>
            </li>

            <li className={classes.listItem}>
              <NavLink
                to="/generateReferalCode"
                className={({ isActive }) =>
                  `${classes?.link} ${isActive ? classes?.activeLink : ""}`
                }
              >
                {t[textTheme].header.navigationList.link3}
              </NavLink>
            </li>
            <li className={classes.listItem}>
              <NavLink
                to="/ReferralsCodes"
                className={({ isActive }) =>
                  `${classes?.link} ${isActive ? classes?.activeLink : ""}`
                }
              >
                Referrals
              </NavLink>
            </li>
          </>
        )}
        <li className={classes.listItem}>
          <NavLink
            to="/sendNotification"
            className={({ isActive }) =>
              `${classes?.link} ${isActive ? classes?.activeLink : ""}`
            }
          >
            {t[textTheme].header.navigationList.link4}
          </NavLink>
        </li>
       
        {isElisyanAdmin && (
          <>
            <li className={classes.listItem}>
              <NavLink
                to="/financialInstitutions"
                className={({ isActive }) =>
                  `${classes?.link} ${isActive ? classes?.activeLink : ""}`
                }
              >
                Financial Institutions
              </NavLink>
            </li>

            <li className={classes.listItem}>
              <NavLink
                to="/errors"
                className={({ isActive }) =>
                  `${classes?.link} ${isActive ? classes?.activeLink : ""}`
                }
              >
                Errors
              </NavLink>
            </li>
          </>
        )}
      </ul>
    </div>
  );
}

export default SideNavigation;
